<div class="search-bar-wide " [ngClass]="{ open: isOpen }">
  <button mat-icon-button class="search-icon-btn" (click)="open()">
    <mat-icon>search</mat-icon>
  </button>
  <div>
    <input autoFocus [formControl]="searchCtrl" class="default-bg" type="text" [placeholder]="placeholder" />
  </div>
  <mat-icon class="search-close text-muted" (click)="close()">close</mat-icon>
</div>
